// these utils are for init
// avoid import framework/utils which imports react and other stuff may causes cirular ref

// framework utils will import and re-export below
const isInSilentLoginIframeFn = (): boolean => {
  const isSilentLogin = window.location.pathname.includes('/authentication/silent_callback')
  if (!isSilentLogin) {
    return false
  }
  try {
    return window.self !== window.top && Boolean(window.frameElement)
  }
  catch (_) {
    return true // not accessible to top
  }
}
export const isInSilentLoginIframe = isInSilentLoginIframeFn()

export const tryParseJson = (str?: string | null) => {
  if (!str) {
    return undefined
  }
  try {
    return JSON.parse(str) || undefined
  }
  catch (e) {
    console.error('failed to parse json', str, e)
    return undefined
  }
}

export const isObject = (o: any) =>
  Object.prototype.toString.call(o) === '[object Object]'

export const isModule = (obj: unknown): boolean => {
  return obj != null && (obj as any)[Symbol.toStringTag] === 'Module'
}

export const isEmptyObject = (obj: Record<string, any>) => {
  for (const _ in obj) {
    return false
  }
  return true
}

const PROTOTYPE_POLLUTION_KEYS = [
  '__proto__',
  'constructor',
  'prototype',
]
export const setNestedValue = (variables: Record<string, any>, keys: string[], value: unknown) => {
  if (keys.some(part => PROTOTYPE_POLLUTION_KEYS.includes(part))) {
    console.error(`skipping variables override for '${keys.join('.')}' to avoid prototype pollution`)
    return variables
  }
  // Create a reference to navigate through the object
  let current = variables

  if (keys.length > 1) {
    // Iterate through all keys except the last one
    for (let i = 0; i < keys.length - 1; i++) {
      const key = keys[i]

      // If current value is null, replace with new object
      if (current[key] === null) {
        current[key] = {}
      }
      // Skip if current level is not an object
      else if (typeof current[key] !== 'object') {
        console.error(`cannot set nested value: ${key} is not an object`, current[key])
        return variables
      }

      // Move to the next level
      current = current[key]
    }
  }

  // Set the final value
  const finalKey = keys[keys.length - 1]
  current[finalKey] = value

  return variables
}

export const overrideVars = <T extends Record<string, any>>(targetVars: T | null | undefined, overrideVars: Partial<T>): T => {
  const vars: T = targetVars || {} as T
  for (const key of Object.keys(overrideVars)) {
    const parts = key.split('.')
    setNestedValue(vars, parts, overrideVars[key])
  }
  return vars
}

export const getShellOverrideConfigKeyByPath = <T extends Record<string, any>>(config: T | null | undefined, pathname: string | undefined): string | undefined => {
  if (!pathname || !config || isEmptyObject(config)) {
    return undefined
  }
  const SLASH = '/'
  if (pathname.includes('/authentication/') && sessionStorage.__sparky_path_override_key) {
    const storedPath = sessionStorage.__sparky_path_override_key as string
    if (config[storedPath]) {
      return pathname
    }
    if (config[SLASH]) {
      return SLASH
    }
    return undefined
  }

  if (config[pathname]) {
    return pathname
  }
  const overridePaths = Object.keys(config).filter(path => path.startsWith(SLASH) && path.length > 1)
  const foundPath = overridePaths.filter(path => (
    pathname === path || pathname.startsWith(path.endsWith(SLASH) ? path : `${path}/`)
  )).reduce((a, b) => ( // get the longest
    a.length > b.length ? a : b
  ), '') || SLASH // default is /
  if (config[foundPath]) {
    return foundPath
  }
  // return undefined
}
